import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Button as BaseButton } from '@beef/legacy-ui-kit';

import { Preloader } from 'components';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Button = ({
  children,
  isLoading,
  disabled,
  transformer,
  wide,
  ...props
}) => (
  <div className={cx('component', { isLoading, transformer, wide })}>
    {isLoading && (
      <Preloader className={cx('preloader')} size="24" />
    )}
    <BaseButton
      {...props}
      transformer={transformer}
      wide={wide}
      disabled={isLoading || disabled}
    >
      <span className={cx('textWrapper')}>
        {children}
      </span>
    </BaseButton>
  </div>
);

Button.propTypes = {
  children: PropTypes.any,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  transformer: PropTypes.bool,
  wide: PropTypes.bool,
};

export default Button;
